import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/esac-points/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'prpRedemption Management',
    meta: {
      title: '@esacPoints.esacPointsManagement.title',
      menuItem: config.app.isOnePlan,
      sorting: config.sidebar.menu.sorting.modules.prp,
      icon: 'app:nav-prp',
    },
    children: [
      {
        path: MODULE_PATH + 'voucher/list',
        component: load('application/esac-points/voucher/esacPointsVoucherList'),
        name: 'esacPoints Voucher List',
        meta: {
          title: '@esacPoints.esacPointsManagement.voucher.listing.title',
          menuItem: true,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'voucher/new/[:memberID]',
        component: load('application/esac-points/voucher/esacPointsVoucherArea'),
        name: 'esacPoints Voucher New',
        props: true,
        meta: {
          title: '@esacPoints.esacPointsManagement.voucher.newVoucher.title',
          menuItem: false,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'voucher/view/[:voucherID]',
        component: load('application/esac-points/voucher/esacPointsVoucherArea'),
        name: 'esacPoints Voucher View',
        props: true,
        meta: {
          title: '@esacPoints.esacPointsManagement.voucher.viewVoucher.title',
          menuItem: false,
          sorting: 5001,
        },
      },
      {
        path: MODULE_PATH + 'redemption/list',
        component: load('application/esac-points/redemption/RedemptionList'),
        name: 'esacPoints Redemption List',
        meta: {
          title: '@esacPoints.esacPointsManagement.redemption.redemptionList.title',
          menuItem: true,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'redemption/new',
        component: load('application/esac-points/redemption/RedemptionArea'),
        name: 'esacPoints Redemption New',
        meta: {
          title: '@esacPoints.esacPointsManagement.redemption.createRedemption.title',
          menuItem: false,
          sorting: 5002,
        },
      },
      {
        path: MODULE_PATH + 'redemption/view',
        component: load('application/esac-points/redemption/RedemptionArea'),
        name: 'esacPoints Redemption Details',
        props: true,
        meta: {
          title: '@esacPoints.esacPointsManagement.redemption.updateRedemption.title',
          menuItem: false,
          sorting: 5002,
        },
      },
    ],
  },
]
